<script>
    import { fade } from 'svelte/transition';

  
</script>
<div  class="main-container" in:fade={{ delay: 250, duration: 500}}>
    <h2 >My skills</h2>
    <div class="column-container">
      <div class="column">
        <div class="skill">
          <img alt="Angular" src="/assets/stacks/angular.png" />
          <div class="rate">
            <label for="star5" title="text">5 stars</label>
            <label for="star4" title="text" class="fill">4 stars</label>
            <label for="star3" title="text" class="fill">3 stars</label>
            <label for="star2" title="text" class="fill">2 stars</label>
            <label for="star1" title="text" class="fill">1 star</label>
          </div>
        </div>
        <div class="skill">
          <img
          alt="React"
            src="https://sujanbyanjankar.com.np/wp-content/uploads/2019/01/React.js_logo-512.png"
          />
          <div class="rate">
            <label for="star5" title="text">5 stars</label>
            <label for="star4" title="text">4 stars</label>
            <label for="star3" title="text">3 stars</label>
            <label for="star2" title="text" class="fill">2 stars</label>
            <label for="star1" title="text" class="fill">1 star</label>
          </div>
        </div>
        <div class="skill">
          <img
          alt="Svelte"

            src="https://raw.githubusercontent.com/sveltejs/svelte/29052aba7d0b78316d3a52aef1d7ddd54fe6ca84/site/static/images/svelte-android-chrome-512.png"
          />
          <div class="rate">
            <label for="star5" title="text">5 stars</label>
            <label for="star4" title="text" class="">4 stars</label>
            <label for="star3" title="text" class="">3 stars</label>
            <label for="star2" title="text" class="fill">2 stars</label>
            <label for="star1" title="text" class="fill">1 star</label>
          </div>
        </div>
        <div class="skill">
          <img 
          alt="SASS"
          src="/assets/stacks/sass.png" />
          <div class="rate">
            <label for="star5" title="text">5 stars</label>
            <label for="star4" title="text" class="fill">4 stars</label>
            <label for="star3" title="text" class="fill">3 stars</label>
            <label for="star2" title="text" class="fill">2 stars</label>
            <label for="star1" title="text" class="fill">1 star</label>
          </div>
        </div>
        <div class="skill">
          <img
          alt="Node"
            src="https://www.kojac.nl/tailwind/images/Backend/nodejs.png"
          />
          <div class="rate">
            <label for="star5" title="text">5 stars</label>
            <label for="star4" title="text" class="">4 stars</label>
            <label for="star3" title="text" class="">3 stars</label>
            <label for="star2" title="text" class="">2 stars</label>
            <label for="star1" title="text" class="fill">1 star</label>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="skill">
          <img
          alt="Unity"

            src="https://cdn4.iconfinder.com/data/icons/logos-brands-5/24/unity-512.png"
          />
          <div class="rate">
            <label for="star5" title="text">5 stars</label>
            <label for="star4" title="text" class="">4 stars</label>
            <label for="star3" title="text" class="fill">3 stars</label>
            <label for="star2" title="text" class="fill">2 stars</label>
            <label for="star1" title="text" class="fill">1 star</label>
          </div>
        </div>
        <div class="skill">
          <img
          alt="Vuforia"

            src="https://www.avrspot.com/wp-content/uploads/2018/06/vuforia-logo.png"
          />
          <div class="rate">
            <label for="star5" title="text">5 stars</label>
            <label for="star4" title="text" class="fill">4 stars</label>
            <label for="star3" title="text" class="fill">3 stars</label>
            <label for="star2" title="text" class="fill">2 stars</label>
            <label for="star1" title="text" class="fill">1 star</label>
          </div>
        </div>
        <div class="skill">
          <img
          alt="ARKit"
            src="https://miro.medium.com/max/256/1*hJdmqVuL79jo8ly7_TvI0Q.png"
          />
          <div class="rate">
            <label for="star5" title="text">5 stars</label>
            <label for="star4" title="text" class="">4 stars</label>
            <label for="star3" title="text" class="fill">3 stars</label>
            <label for="star2" title="text" class="fill">2 stars</label>
            <label for="star1" title="text" class="fill">1 star</label>
          </div>
        </div>
        <div class="skill">
          <img
          alt="AR js"
            src="https://zenprospect-production.s3.amazonaws.com/uploads/pictures/605caf6df029e30001baf768/picture"
          />
          <div class="rate">
            <label for="star5" title="text">5 stars</label>
            <label for="star4" title="text" class="">4 stars</label>
            <label for="star3" title="text" class="fill">3 stars</label>
            <label for="star2" title="text" class="fill">2 stars</label>
            <label for="star1" title="text" class="fill">1 star</label>
          </div>
        </div>
        <div class="skill">
          <img
          alt="AFrame"
            src="https://upload.wikimedia.org/wikipedia/commons/9/92/A-Frame_logo.png"
          />
          <div class="rate">
            <label for="star5" title="text">5 stars</label>
            <label for="star4" title="text" class="">4 stars</label>
            <label for="star3" title="text" class="fill">3 stars</label>
            <label for="star2" title="text" class="fill">2 stars</label>
            <label for="star1" title="text" class="fill">1 star</label>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="skill">
          <img 
          alt="Firebase"
          src="/assets/stacks/firebase.png" />
          <div class="rate">
            <label for="star5" title="text">5 stars</label>
            <label for="star4" title="text" class="">4 stars</label>
            <label for="star3" title="text" class="">3 stars</label>
            <label for="star2" title="text" class="fill">2 stars</label>
            <label for="star1" title="text" class="fill">1 star</label>
          </div>
        </div>
        <div class="skill">
          <img 
          alt="Flutter"

          src="/assets/stacks/flutter.png"/>
          <div class="rate">
            <label for="star5" title="text">5 stars</label>
            <label for="star4" title="text" class="">4 stars</label>
            <label for="star3" title="text" class="">3 stars</label>
            <label for="star2" title="text" class="">2 stars</label>
            <label for="star1" title="text" class="fill">1 star</label>
          </div>
        </div>
      </div>
      <div class="model-container">
        <model-viewer
          src="assets/models/KingKong.glb"
          ar
          ar-modes="webxr scene-viewer quick-look"
          seamless-poster
          shadow-intensity="1"
          camera-controls
        ></model-viewer>
        <p style="font-size: small; text-align: center; color: black">
          3D model by:
          <a href="https://artsandculture.google.com/project/ar">Google</a>
        </p>
      </div>
    </div>
</div>
<style>
  @charset "UTF-8";
.main-container {
  color: white;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
          width: 85vw !important;

}

.column-container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
      -ms-flex-direction: row;
          flex-direction: row;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  -ms-flex-pack: distribute;
      justify-content: space-around;
}

img {
  width: 5vw;
}

.skill {
  margin: 15px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
      -ms-flex-direction: row;
          flex-direction: row;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}

.rate {
  padding-left: 10px;
}

.rate > label {
  float: right;
  width: 1em;
  overflow: hidden;
  white-space: nowrap;
  cursor: pointer;
  font-size: 30px;
  color: #ccc;
}

.rate:not(:checked) > label:before {
  content: "★ ";
}

.fill:before {
  color: #ffc700;
}

.model-container {
  width: 25vw;
  height: 60vh;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -ms-flex-wrap: nowrap;
      flex-wrap: nowrap;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}

model-viewer {
  height: 100%;
  width: 100%;
}

@media only screen and (max-width: 650px) {
  .main-container {
    top: 2vh;
    left: 0;
    margin: 2%;
  }
  img {
    width: 20vw;
  }
}

@media only screen and (min-width: 650px) and (max-width: 850px) {
  .main-container {
    top: 8vh;
    left: 5vw;
  }
}

@media only screen and (min-width: 850px) and (max-width: 1000px) {
  .main-container {
    left: 10vw;
  }
}

@media only screen and (min-width: 1000px) and (max-width: 1200px) {
  
  .main-container {
    left: 20vw;
  }
  
}

/*# sourceMappingURL=stack.css.map */
</style>